import { FILING_STATUS_ENUM } from './components/Pages/Reports/constants'

interface StateOption {
    text: string;
    value: string;
};

export interface ITaxBracket {
    value: number;
    text: string;
}

export interface IStateFilingStatus {
    [FILING_STATUS_ENUM.SINGLE]?: ITaxBracket[];
    [FILING_STATUS_ENUM.FILLING_SEPARATELY]?: ITaxBracket[];
    [FILING_STATUS_ENUM.HEAD]?: ITaxBracket[];
    [FILING_STATUS_ENUM.FILLING_JOINTLY]?: ITaxBracket[];
}

export interface IStateNoIncomeTax {
    value: number;
    text: string;
}

export interface IStateTaxRates {
    [key: string]: IStateFilingStatus | IStateNoIncomeTax[];
}

export const STATE_TAX_RATE: IStateTaxRates = {
    AL: { // Alabama
      [FILING_STATUS_ENUM.SINGLE]: [
        { value: 2,    text: "$0 to $500" },
        { value: 4,    text: "$500.01 to $3,000" },
        { value: 5,    text: "Over $3,000" }
      ],
      [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
        { value: 2,    text: "$0 to $500" },
        { value: 4,    text: "$500.01 to $3,000" },
        { value: 5,    text: "Over $3,000" }
      ],
      [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
        { value: 2,    text: "$0 to $1,000" },
        { value: 4,    text: "$1,000.01 to $6,000" },
        { value: 5,    text: "Over $6,000" }
      ],
      [FILING_STATUS_ENUM.HEAD]: [
        { value: 2,    text: "$0 to $500" },
        { value: 4,    text: "$500.01 to $3,000" },
        { value: 5,    text: "Over $3,000" }
      ]
    },
    AK: [{ // Alaska
        value: 0,
        text: 'Does not have state income tax'
    }],
    AZ: [{ // Arizona
        value: 2.5,
        text: 'Flat rate'
    }],
    AR: { // Arkansas
      [FILING_STATUS_ENUM.SINGLE]: [
        { value: 2,    text: "$0 to $4,400" },
        { value: 3,    text: "$4,401 to $8,800" },
        { value: 3.9,  text: "Over $8,800" }
      ],
      [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
        { value: 2,    text: "$0 to $4,400" },
        { value: 3,    text: "$4,401 to $8,800" },
        { value: 3.9,  text: "Over $8,800" }
      ],
      [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
        { value: 2,    text: "$0 to $4,400" },
        { value: 3,    text: "$4,401 to $8,800" },
        { value: 3.9,  text: "Over $8,800" }
      ],
      [FILING_STATUS_ENUM.HEAD]: [
        { value: 2,    text: "$0 to $4,400" },
        { value: 3,    text: "$4,401 to $8,800" },
        { value: 3.9,  text: "Over $8,800" }
      ]
    },
    CA: { // California
        [FILING_STATUS_ENUM.SINGLE]: [
            { value: 1, text: '$0 to $10,756' },
            { value: 2, text: '$10,757 to $25,499' },
            { value: 4, text: '$25,500 to $40,245' },
            { value: 6, text: '$40,246 to $55,866' },
            { value: 8, text: '$55,867 to $70,606' },
            { value: 9.3, text: '$70,607 to $360,659' },
            { value: 10.3, text: '$360,660 to $432,787' },
            { value: 11.3, text: '$432,788 to $721,314' },
            { value: 12.3, text: '$721,315 or more' },
        ],
        [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
            { value: 1, text: '$0 to $21,512' },
            { value: 2, text: '$21,513 to $50,998' },
            { value: 4, text: '$50,999 to $80,490' },
            { value: 6, text: '$80,491 to $111,732' },
            { value: 8, text: '$111,733 to $141,212' },
            { value: 9.3, text: '$141,213 to $721,318' },
            { value: 10.3, text: '$721,319 to $865,574' },
            { value: 11.3, text: '$865,575 to $1,442,628' },
            { value: 12.3, text: '$1,442,629 or more' },
        ],
        [FILING_STATUS_ENUM.HEAD]: [
            { value: 1, text: '$0 to $21,527' },
            { value: 2, text: '$21,528 to $51,000' },
            { value: 4, text: '$51,001 to $65,744' },
            { value: 6, text: '$65,745 to $81,364' },
            { value: 8, text: '$81,365 to $96,107' },
            { value: 9.3, text: '$96,108 to $490,493' },
            { value: 10.3, text: '$490,494 to $588,593' },
            { value: 11.3, text: '$588,593 to $980,987' },
            { value: 12.3, text: '$980,988 or more' },
        ],
        [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
            { value: 1, text: '$0 to $10,756' },
            { value: 2, text: '$10,757 to $25,499' },
            { value: 4, text: '$25,500 to $40,245' },
            { value: 6, text: '$40,246 to $55,866' },
            { value: 8, text: '$55,867 to $70,606' },
            { value: 9.3, text: '$70,607 to $360,659' },
            { value: 10.3, text: '$360,660 to $432,787' },
            { value: 11.3, text: '$432,788 to $721,314' },
            { value: 12.3, text: '$721,315 or more' },
        ],
    },
    CO: [{ // Colorado
        value: 4.4,
        text: 'Flat rate'
    }],
    CT: { // Connecticut
    [FILING_STATUS_ENUM.SINGLE]: [
      { value: 2,    text: "$0 to $10,000" },
      { value: 4.5,  text: "$10,001 to $50,000" },
      { value: 5.5,  text: "$50,001 to $100,000" },
      { value: 6,    text: "$100,001 to $200,000" },
      { value: 6.5,  text: "$200,001 to $250,000" },
      { value: 6.9,  text: "$250,001 to $500,000" },
      { value: 6.99, text: "Over $500,000" }
    ],
    [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
      { value: 2,    text: "$0 to $10,000" },
      { value: 4.5,  text: "$10,001 to $50,000" },
      { value: 5.5,  text: "$50,001 to $100,000" },
      { value: 6,    text: "$100,001 to $200,000" },
      { value: 6.5,  text: "$200,001 to $250,000" },
      { value: 6.9,  text: "$250,001 to $500,000" },
      { value: 6.99, text: "Over $500,000" }
    ],
    [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
      { value: 2,    text: "$0 to $20,000" },
      { value: 4.5,  text: "$20,001 to $100,000" },
      { value: 5.5,  text: "$100,001 to $200,000" },
      { value: 6,    text: "$200,001 to $400,000" },
      { value: 6.5,  text: "$400,001 to $500,000" },
      { value: 6.9,  text: "$500,001 to $1,000,000" },
      { value: 6.99, text: "Over $1,000,000" }
    ],
    [FILING_STATUS_ENUM.HEAD]: [
      { value: 2,    text: "$0 to $16,000" },
      { value: 4.5,  text: "$16,001 to $80,000" },
      { value: 5.5,  text: "$80,001 to $160,000" },
      { value: 6,    text: "$160,001 to $320,000" },
      { value: 6.5,  text: "$320,001 to $400,000" },
      { value: 6.9,  text: "$400,001 to $800,000" },
      { value: 6.99, text: "Over $800,000" }
    ]
  },
    DE: { // Delaware
      [FILING_STATUS_ENUM.SINGLE]: [
        { value: 0,    text: "$0 to $2,000" },
        { value: 2.2,  text: "$2,000.01 to $5,000" },
        { value: 3.9,  text: "$5,000.01 to $10,000" },
        { value: 4.8,  text: "$10,000.01 to $20,000" },
        { value: 5.2,  text: "$20,000.01 to $25,000" },
        { value: 5.55, text: "$25,000.01 to $60,000" },
        { value: 6.6,  text: "Over $60,000" }
      ],
      [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
        { value: 0,    text: "$0 to $2,000" },
        { value: 2.2,  text: "$2,000.01 to $5,000" },
        { value: 3.9,  text: "$5,000.01 to $10,000" },
        { value: 4.8,  text: "$10,000.01 to $20,000" },
        { value: 5.2,  text: "$20,000.01 to $25,000" },
        { value: 5.55, text: "$25,000.01 to $60,000" },
        { value: 6.6,  text: "Over $60,000" }
      ],
      [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
        { value: 0,    text: "$0 to $2,000" },
        { value: 2.2,  text: "$2,000.01 to $5,000" },
        { value: 3.9,  text: "$5,000.01 to $10,000" },
        { value: 4.8,  text: "$10,000.01 to $20,000" },
        { value: 5.2,  text: "$20,000.01 to $25,000" },
        { value: 5.55, text: "$25,000.01 to $60,000" },
        { value: 6.6,  text: "Over $60,000" }
      ],
      [FILING_STATUS_ENUM.HEAD]: [
        { value: 0,    text: "$0 to $2,000" },
        { value: 2.2,  text: "$2,000.01 to $5,000" },
        { value: 3.9,  text: "$5,000.01 to $10,000" },
        { value: 4.8,  text: "$10,000.01 to $20,000" },
        { value: 5.2,  text: "$20,000.01 to $25,000" },
        { value: 5.55, text: "$25,000.01 to $60,000" },
        { value: 6.6,  text: "Over $60,000" }
      ]
    },
    DC: { //  District of Columbia
      [FILING_STATUS_ENUM.SINGLE]: [
        { value: 4,    text: "$0 to $10,000" },
        { value: 6,    text: "$10,000.01 to $40,000" },
        { value: 6.5,  text: "$40,000.01 to $60,000" },
        { value: 8.5,  text: "$60,000.01 to $250,000" },
        { value: 9.25, text: "$250,000.01 to $500,000" },
        { value: 9.75, text: "$500,000.01 to $1,000,000" },
        { value: 10.75, text: "Over $1,000,000" }
      ],
      [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
        { value: 4,    text: "$0 to $10,000" },
        { value: 6,    text: "$10,000.01 to $40,000" },
        { value: 6.5,  text: "$40,000.01 to $60,000" },
        { value: 8.5,  text: "$60,000.01 to $250,000" },
        { value: 9.25, text: "$250,000.01 to $500,000" },
        { value: 9.75, text: "$500,000.01 to $1,000,000" },
        { value: 10.75, text: "Over $1,000,000" }
      ],
      [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
        { value: 4,    text: "$0 to $10,000" },
        { value: 6,    text: "$10,000.01 to $40,000" },
        { value: 6.5,  text: "$40,000.01 to $60,000" },
        { value: 8.5,  text: "$60,000.01 to $250,000" },
        { value: 9.25, text: "$250,000.01 to $500,000" },
        { value: 9.75, text: "$500,000.01 to $1,000,000" },
        { value: 10.75, text: "Over $1,000,000" }
      ],
      [FILING_STATUS_ENUM.HEAD]: [
        { value: 4,    text: "$0 to $10,000" },
        { value: 6,    text: "$10,000.01 to $40,000" },
        { value: 6.5,  text: "$40,000.01 to $60,000" },
        { value: 8.5,  text: "$60,000.01 to $250,000" },
        { value: 9.25, text: "$250,000.01 to $500,000" },
        { value: 9.75, text: "$500,000.01 to $1,000,000" },
        { value: 10.75, text: "Over $1,000,000" }
      ]
    },
    FL: [{ // Florida
        value: 0,
        text: "Does not have state income tax"
    }],
    GA: [{ // Georgia
        value: 5.39,
        text: "Flat rate"
    }],
    HI: { // Hawaii
    [FILING_STATUS_ENUM.SINGLE]: [
      { value: 1.4,   text: "$0 to $2,400" },
      { value: 3.2,   text: "$2,401 to $4,800" },
      { value: 5.5,   text: "$4,801 to $9,600" },
      { value: 6.4,   text: "$9,601 to $14,400" },
      { value: 6.8,   text: "$14,401 to $19,200" },
      { value: 7.2,   text: "$19,201 to $24,000" },
      { value: 7.6,   text: "$24,001 to $36,000" },
      { value: 7.9,   text: "$36,001 to $48,000" },
      { value: 8.25,  text: "$48,001 to $150,000" },
      { value: 9,     text: "$150,001 to $175,000" },
      { value: 10,    text: "$175,001 to $200,000" },
      { value: 11,    text: "Over $200,000" }
    ],
    [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
      { value: 1.4,   text: "$0 to $2,400" },
      { value: 3.2,   text: "$2,401 to $4,800" },
      { value: 5.5,   text: "$4,801 to $9,600" },
      { value: 6.4,   text: "$9,601 to $14,400" },
      { value: 6.8,   text: "$14,401 to $19,200" },
      { value: 7.2,   text: "$19,201 to $24,000" },
      { value: 7.6,   text: "$24,001 to $36,000" },
      { value: 7.9,   text: "$36,001 to $48,000" },
      { value: 8.25,  text: "$48,001 to $150,000" },
      { value: 9,     text: "$150,001 to $175,000" },
      { value: 10,    text: "$175,001 to $200,000" },
      { value: 11,    text: "Over $200,000" }
    ],
    [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
      { value: 1.4,   text: "$0 to $4,800" },
      { value: 3.2,   text: "$4,801 to $9,600" },
      { value: 5.5,   text: "$9,601 to $19,200" },
      { value: 6.4,   text: "$19,201 to $28,800" },
      { value: 6.8,   text: "$28,801 to $38,400" },
      { value: 7.2,   text: "$38,401 to $48,000" },
      { value: 7.6,   text: "$48,001 to $72,000" },
      { value: 7.9,   text: "$72,001 to $96,000" },
      { value: 8.25,  text: "$96,001 to $300,000" },
      { value: 9,     text: "$300,001 to $350,000" },
      { value: 10,    text: "$350,001 to $400,000" },
      { value: 11,    text: "Over $400,000" }
    ],
    [FILING_STATUS_ENUM.HEAD]: [
      { value: 1.4,   text: "$0 to $3,200" },
      { value: 3.2,   text: "$3,201 to $6,400" },
      { value: 5.5,   text: "$6,401 to $12,800" },
      { value: 6.4,   text: "$12,801 to $19,200" },
      { value: 6.8,   text: "$19,201 to $25,600" },
      { value: 7.2,   text: "$25,601 to $32,000" },
      { value: 7.6,   text: "$32,001 to $48,000" },
      { value: 7.9,   text: "$48,001 to $64,000" },
      { value: 8.25,  text: "$64,001 to $192,000" },
      { value: 9,     text: "$192,001 to $224,000" },
      { value: 10,    text: "$224,001 to $256,000" },
      { value: 11,    text: "Over $256,000" }
    ]
  },
    ID: [{ // Idaho
        value: 5.695,
        text: "Flat rate"
    }],
    IL: [{ // Illinois
        value: 4.95,
        text: "Flat rate"
    }],
    IN: [{ // Indiana
        value: 3,
        text: "Flat rate"
    }],
    IA: [{ // Iowa
      value: 3.8,
      text: "Flat rate"
    }],
    KS: { // Kansas
      [FILING_STATUS_ENUM.SINGLE]: [
        { value: 5.2,  text: "$0 to $23,000" },
        { value: 5.58, text: "Over $23,000" }
      ],
      [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
        { value: 5.2,  text: "$0 to $23,000" },
        { value: 5.58, text: "Over $23,000" }
      ],
      [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
        { value: 5.2,  text: "$0 to $46,000" },
        { value: 5.58, text: "Over $46,000" }
      ],
      [FILING_STATUS_ENUM.HEAD]: [
        { value: 5.2,  text: "$0 to $23,000" },
        { value: 5.58, text: "Over $23,000" }
      ]
    },
    KY: [{ // Kentucky
        value: 4,
        text: "Flat rate"
    }],
    LA: [{ // Louisiana
      value: 3,
      text: "Flat rate"
    }],
    ME: { // Maine
      [FILING_STATUS_ENUM.SINGLE]: [
        { value: 5.8,  text: "$0 to $26,800" },
        { value: 6.75, text: "$26,801 to $63,450" },
        { value: 7.15, text: "Over $63,450" }
      ],
      [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
        { value: 5.8,  text: "$0 to $26,800" },
        { value: 6.75, text: "$26,801 to $63,450" },
        { value: 7.15, text: "Over $63,450" }
      ],
      [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
        { value: 5.8,  text: "$0 to $53,600" },
        { value: 6.75, text: "$53,601 to $126,900" },
        { value: 7.15, text: "Over $126,900" }
      ],
      [FILING_STATUS_ENUM.HEAD]: [
        { value: 5.8,  text: "$0 to $39,050" },
        { value: 6.75, text: "$39,051 to $92,450" },
        { value: 7.15, text: "Over $92,450" }
      ]
    },
    MD: { // Maryland
      [FILING_STATUS_ENUM.SINGLE]: [
        { value: 2, text: "$0 to $1,000" },
        { value: 3, text: "$1,001 to $2,000" },
        { value: 4, text: "$2,001 to $3,000" },
        { value: 4.75, text: "$3,001 to $100,000" },
        { value: 5, text: "$100,001 to $125,000" },
        { value: 5.25, text: "$125,001 to $150,000" },
        { value: 5.5, text: "$150,001 to $250,000" },
        { value: 5.75, text: "Over $250,000" }
      ],
      [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
        { value: 2, text: "$0 to $1,000" },
        { value: 3, text: "$1,001 to $2,000" },
        { value: 4, text: "$2,001 to $3,000" },
        { value: 4.75, text: "$3,001 to $100,000" },
        { value: 5, text: "$100,001 to $125,000" },
        { value: 5.25, text: "$125,001 to $150,000" },
        { value: 5.5, text: "$150,001 to $250,000" },
        { value: 5.75, text: "Over $250,000" }
      ],
      [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
        { value: 2, text: "$0 to $1,000" },
        { value: 3, text: "$1,001 to $2,000" },
        { value: 4, text: "$2,001 to $3,000" },
        { value: 4.75, text: "$3,001 to $150,000" },
        { value: 5, text: "$150,001 to $175,000" },
        { value: 5.25, text: "$175,001 to $225,000" },
        { value: 5.5, text: "$225,001 to $300,000" },
        { value: 5.75, text: "Over $300,000" }
      ],
      [FILING_STATUS_ENUM.HEAD]: [
        { value: 2, text: "$0 to $1,000" },
        { value: 3, text: "$1,001 to $2,000" },
        { value: 4, text: "$2,001 to $3,000" },
        { value: 4.75, text: "$3,001 to $100,000" },
        { value: 5, text: "$100,001 to $125,000" },
        { value: 5.25, text: "$125,001 to $150,000" },
        { value: 5.5, text: "$150,001 to $250,000" },
        { value: 5.75, text: "Over $250,000" }
      ]
    },
    MA: [ // Massachusetts
        { value: 5, text: "Up to $1,000,000" },
        { value: 9, text: "Over $1,000,000" }
    ],
    MI: [{ // Michigan
        value: 4.25,
        text: "Flat rate"
    }],
    MN: { // Minnesota
        [FILING_STATUS_ENUM.SINGLE]: [
            { value: 5.35, text: "$0 to $32,570" },
            { value: 6.8, text: "$32,571 to $106,990" },
            { value: 7.85, text: "$106,991 to $198,630" },
            { value: 9.85, text: "Over $198,630" }
        ],
        [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
            { value: 5.35, text: "$0 to $47,620" },
            { value: 6.8, text: "$47,621 to $189,180" },
            { value: 7.85, text: "$189,181 to $330,410" },
            { value: 9.85, text: "Over $330,410" }
        ],
        [FILING_STATUS_ENUM.HEAD]: [
            { value: 5.35, text: "$0 to $40,100" },
            { value: 6.8, text: "$40,101 to $161,130" },
            { value: 7.85, text: "$161,131 to $264,050" },
            { value: 9.85, text: "Over $264,050" }
        ],
        [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
            { value: 5.35, text: "$0 to $23,810" },
            { value: 6.8, text: "$23,811 to $94,590" },
            { value: 7.85, text: "$94,591 to $165,205" },
            { value: 9.85, text: "Over $165,205" }
        ]
    },
    MS: [{ // Mississippi
        value: 4.4,
        text: "Flat rate"
    }],
    MO: { // Missouri
      [FILING_STATUS_ENUM.SINGLE]: [
        { value: 0, text: "$0 to $1,000" },
        { value: 2, text: "$1,001 to $2,000" },
        { value: 2.5, text: "$2,001 to $3,000" },
        { value: 3, text: "$3,001 to $4,000" },
        { value: 3.5, text: "$4,001 to $5,000" },
        { value: 4, text: "$5,001 to $7,000" },
        { value: 4.5, text: "$7,001 to $8,911" },
        { value: 4.7, text: "Over $8,911" }
      ],
      [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
        { value: 0, text: "$0 to $1,000" },
        { value: 2, text: "$1,001 to $2,000" },
        { value: 2.5, text: "$2,001 to $3,000" },
        { value: 3, text: "$3,001 to $4,000" },
        { value: 3.5, text: "$4,001 to $5,000" },
        { value: 4, text: "$5,001 to $7,000" },
        { value: 4.5, text: "$7,001 to $8,911" },
        { value: 4.7, text: "Over $8,911" }
      ],
      [FILING_STATUS_ENUM.HEAD]: [
        { value: 0, text: "$0 to $1,000" },
        { value: 2, text: "$1,001 to $2,000" },
        { value: 2.5, text: "$2,001 to $3,000" },
        { value: 3, text: "$3,001 to $4,000" },
        { value: 3.5, text: "$4,001 to $5,000" },
        { value: 4, text: "$5,001 to $7,000" },
        { value: 4.5, text: "$7,001 to $8,911" },
        { value: 4.7, text: "Over $8,911" }
      ],
      [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
        { value: 0, text: "$0 to $1,000" },
        { value: 2, text: "$1,001 to $2,000" },
        { value: 2.5, text: "$2,001 to $3,000" },
        { value: 3, text: "$3,001 to $4,000" },
        { value: 3.5, text: "$4,001 to $5,000" },
        { value: 4, text: "$5,001 to $7,000" },
        { value: 4.5, text: "$7,001 to $8,911" },
        { value: 4.7, text: "Over $8,911" }
      ]
    },
    MT: { // Montana
        [FILING_STATUS_ENUM.SINGLE]: [
          { value: 4.7, text: "$0 to $21,100" },
          { value: 5.9, text: "Over $21,100" }
        ],
        [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
          { value: 4.7, text: "$0 to $21,100" },
          { value: 5.9, text: "Over $21,100" }
        ],
        [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
          { value: 4.7, text: "$0 to $42,200" },
          { value: 5.9, text: "Over $42,200" }
        ],
        [FILING_STATUS_ENUM.HEAD]: [
          { value: 4.7, text: "$0 to $31,700" },
          { value: 5.9, text: "Over $31,700" }
        ]
    },
    NE: { // Nebraska
      [FILING_STATUS_ENUM.SINGLE]: [
        { value: 2.46, text: "$0 to $2,999" },
        { value: 3.51, text: "$3,000 to $17,999" },
        { value: 5.01, text: "$18,000 to $29,999" },
        { value: 5.2, text: "Over $29,999" }
      ],
      [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
        { value: 2.46, text: "$0 to $2,999" },
        { value: 3.51, text: "$3,000 to $17,999" },
        { value: 5.01, text: "$18,000 to $29,999" },
        { value: 5.2, text: "Over $29,999" }
      ],
      [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
        { value: 2.46, text: "$0 to $5,999" },
        { value: 3.51, text: "$6,000 to $35,999" },
        { value: 5.01, text: "$36,000 to $59,999" },
        { value: 5.2, text: "Over $59,999" }
      ],
      [FILING_STATUS_ENUM.HEAD]: [
        { value: 2.46, text: "$0 to $5,599" },
        { value: 3.51, text: "$5,600 to $28,799" },
        { value: 5.01, text: "$28,800 to $43,999" },
        { value: 5.2, text: "Over $43,999" }
      ]
    },
    NV: [{ // Nevada
        value: 0,
        text: "Does not have state income tax"
    }],
    NH: [{  // New Hampshire
        value: 0,
        text: "Does not have state income tax"
    }],
    NJ: { // New Jersey
      [FILING_STATUS_ENUM.SINGLE]: [
        { value: 1.4,   text: "$0 to $20,000" },
        { value: 1.75,  text: "$20,001 to $35,000" },
        { value: 3.5,   text: "$35,001 to $40,000" },
        { value: 5.525, text: "$40,001 to $75,000" },
        { value: 6.37,  text: "$75,001 to $500,000" },
        { value: 8.97,  text: "$500,001 to $1,000,000" },
        { value: 10.75, text: "Over $1,000,000" }
      ],
      [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
        { value: 1.4,   text: "$0 to $20,000" },
        { value: 1.75,  text: "$20,001 to $35,000" },
        { value: 3.5,   text: "$35,001 to $40,000" },
        { value: 5.525, text: "$40,001 to $75,000" },
        { value: 6.37,  text: "$75,001 to $500,000" },
        { value: 8.97,  text: "$500,001 to $1,000,000" },
        { value: 10.75, text: "Over $1,000,000" }
      ],
      [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
        { value: 1.4,   text: "$0 to $20,000" },
        { value: 1.75,  text: "$20,001 to $50,000" },
        { value: 2.45,  text: "$50,001 to $70,000" },
        { value: 3.5,   text: "$70,001 to $80,000" },
        { value: 5.525, text: "$80,001 to $150,000" },
        { value: 6.37,  text: "$150,001 to $500,000" },
        { value: 8.97,  text: "$500,001 to $1,000,000" },
        { value: 10.75, text: "Over $1,000,000" }
      ],
      [FILING_STATUS_ENUM.HEAD]: [
        { value: 1.4,   text: "$0 to $20,000" },
        { value: 1.75,  text: "$20,001 to $50,000" },
        { value: 2.45,  text: "$50,001 to $70,000" },
        { value: 3.5,   text: "$70,001 to $80,000" },
        { value: 5.525, text: "$80,001 to $150,000" },
        { value: 6.37,  text: "$150,001 to $500,000" },
        { value: 8.97,  text: "$500,001 to $1,000,000" },
        { value: 10.75, text: "Over $1,000,000" }
      ]
    },
    NM: { // New Mexico
      [FILING_STATUS_ENUM.SINGLE]: [
        { value: 1.5,   text: "$0 to $5,500" },
        { value: 3.2,   text: "$5,501 to $11,000" },
        { value: 4.7,   text: "$11,001 to $16,000" },
        { value: 4.9,   text: "$16,001 to $210,000" },
        { value: 5.9,   text: "Over $210,000" }
      ],
      [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
        { value: 1.5,   text: "$0 to $4,000" },
        { value: 3.2,   text: "$4,001 to $8,000" },
        { value: 4.7,   text: "$8,001 to $12,000" },
        { value: 4.9,   text: "$12,001 to $157,500" },
        { value: 5.9,   text: "Over $157,500" }
      ],
      [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
        { value: 1.5,   text: "$0 to $8,000" },
        { value: 3.2,   text: "$8,001 to $16,000" },
        { value: 4.7,   text: "$16,001 to $24,000" },
        { value: 4.9,   text: "$24,001 to $315,000" },
        { value: 5.9,   text: "Over $315,000" }
      ],
      [FILING_STATUS_ENUM.HEAD]: [
        { value: 1.5,   text: "$0 to $5,500" },
        { value: 3.2,   text: "$5,501 to $11,000" },
        { value: 4.7,   text: "$11,001 to $16,000" },
        { value: 4.9,   text: "$16,001 to $210,000" },
        { value: 5.9,   text: "Over $210,000" }
      ]
    },
    NY: { // New York
        [FILING_STATUS_ENUM.SINGLE]: [
            { value: 4, text: "$0 to $8,500" },
            { value: 4.5, text: "$8,501 to $11,700" },
            { value: 5.25, text: "$11,701 to $13,900" },
            { value: 5.5, text: "$13,901 to $80,650" },
            { value: 6, text: "$80,651 to $215,400" },
            { value: 6.85, text: "$215,401 to $1,077,550" },
            { value: 9.65, text: "$1,077,551 to $5,000,000" },
            { value: 10.3, text: "$5,000,001 to $25,000,000" },
            { value: 10.9, text: "$25,000,001 and over" }
        ],
        [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
            { value: 4, text: "$0 to $17,150" },
            { value: 4.5, text: "$17,151 to $23,600" },
            { value: 5.25, text: "$23,601 to $27,900" },
            { value: 5.5, text: "$27,901 to $161,550" },
            { value: 6, text: "$161,551 to $323,200" },
            { value: 6.85, text: "$323,201 to $2,155,350" },
            { value: 9.65, text: "$2,155,351 to $5,000,000" },
            { value: 10.3, text: "$5,000,001 to $25,000,000" },
            { value: 10.9, text: "$25,000,001 and over" }
        ],
        [FILING_STATUS_ENUM.HEAD]: [
            { value: 4, text: "$0 to $12,800" },
            { value: 4.5, text: "$12,801 to $17,650" },
            { value: 5.25, text: "$17,651 to $20,900" },
            { value: 5.5, text: "$20,901 to $107,650" },
            { value: 6, text: "$107,651 to $269,300" },
            { value: 6.85, text: "$269,301 to $1,616,450" },
            { value: 9.65, text: "$1,616,451 to $5,000,000" },
            { value: 10.3, text: "$5,000,001 to $25,000,000" },
            { value: 10.9, text: "$25,000,001 and over" }
        ],
        [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
            { value: 4, text: "$0 to $8,500" },
            { value: 4.5, text: "$8,501 to $11,700" },
            { value: 5.25, text: "$11,701 to $13,900" },
            { value: 5.5, text: "$$13,901 to $80,650" },
            { value: 6, text: "$80,651 to $215,400" },
            { value: 6.85, text: "$215,401 to $1,077,550" },
            { value: 9.65, text: "$1,077,551 to $5,000,000" },
            { value: 10.3, text: "$5,000,001 to $25,000,000" },
            { value: 10.9, text: "$25,000,001 and over" }
        ]
    },
    NC: [{ // North Carolina
        value: 4.25,
        text: "Flat rate"
    }],
    ND: { // North Dakota
      [FILING_STATUS_ENUM.SINGLE]: [
        { value: 1.95,  text: "$0 to $55,975" },
        { value: 2.5,   text: "Over $55,975" }
      ],
      [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
        { value: 1.95,  text: "$0 to $55,488" },
        { value: 2.5,   text: "Over $55,488" }
      ],
      [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
        { value: 1.95,  text: "$0 to $111,950" },
        { value: 2.5,   text: "Over $111,950" }
      ],
      [FILING_STATUS_ENUM.HEAD]: [
        { value: 1.95,  text: "$0 to $76,200" },
        { value: 2.5,   text: "Over $76,200" }
      ]
    },
    OH: {  // Ohio
      [FILING_STATUS_ENUM.SINGLE]: [
        { value: 2.75,  text: "$0 to $26,050" },
        { value: 3.5,   text: "Over $26,050" }
      ],
      [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
        { value: 2.75,  text: "$0 to $26,050" },
        { value: 3.5,   text: "Over $26,050" }
      ],
      [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
        { value: 2.75,  text: "$0 to $26,050" },
        { value: 3.5,   text: "Over $26,050" }
      ],
      [FILING_STATUS_ENUM.HEAD]: [
        { value: 2.75,  text: "$0 to $26,050" },
        { value: 3.5,   text: "Over $26,050" }
      ]
    },
    OK: { // Oklahoma
      [FILING_STATUS_ENUM.SINGLE]: [
        { value: 0.25,  text: "$0 to $1,000" },
        { value: 0.75,  text: "$1,000.01 to $2,500" },
        { value: 1.75,  text: "$2,500.01 to $3,750" },
        { value: 2.75,  text: "$3,750.01 to $4,900" },
        { value: 3.75,  text: "$4,900.01 to $7,200" },
        { value: 4.75,  text: "Over $7,200" }
      ],
      [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
        { value: 0.25,  text: "$0 to $1,000" },
        { value: 0.75,  text: "$1,000.01 to $2,500" },
        { value: 1.75,  text: "$2,500.01 to $3,750" },
        { value: 2.75,  text: "$3,750.01 to $4,900" },
        { value: 3.75,  text: "$4,900.01 to $7,200" },
        { value: 4.75,  text: "Over $7,200" }
      ],
      [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
        { value: 0.25,  text: "$0 to $2,000" },
        { value: 0.75,  text: "$2,000.01 to $5,000" },
        { value: 1.75,  text: "$5,000.01 to $7,500" },
        { value: 2.75,  text: "$7,500.01 to $9,800" },
        { value: 3.75,  text: "$9,800.01 to $14,400" },
        { value: 4.75,  text: "Over $14,400" }
      ],
      [FILING_STATUS_ENUM.HEAD]: [
        { value: 0.25,  text: "$0 to $1,000" },
        { value: 0.75,  text: "$1,000.01 to $2,500" },
        { value: 1.75,  text: "$2,500.01 to $3,750" },
        { value: 2.75,  text: "$3,750.01 to $4,900" },
        { value: 3.75,  text: "$4,900.01 to $7,200" },
        { value: 4.75,  text: "Over $7,200" }
      ]
    },
    OR: { // Oregon
      [FILING_STATUS_ENUM.SINGLE]: [
        { value: 4.75,  text: "$0 to $4,400" },
        { value: 6.75,  text: "$4,401 to $11,050" },
        { value: 8.75,  text: "$11,051 to $125,000" },
        { value: 9.9,   text: "Over $125,000" }
      ],
      [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
        { value: 4.75,  text: "$0 to $4,400" },
        { value: 6.75,  text: "$4,401 to $11,050" },
        { value: 8.75,  text: "$11,051 to $125,000" },
        { value: 9.9,   text: "Over $125,000" }
      ],
      [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
        { value: 4.75,  text: "$0 to $8,800" },
        { value: 6.75,  text: "$8,801 to $22,100" },
        { value: 8.75,  text: "$22,101 to $250,000" },
        { value: 9.9,   text: "Over $250,000" }
      ],
      [FILING_STATUS_ENUM.HEAD]: [
        { value: 4.75,  text: "$0 to $4,400" },
        { value: 6.75,  text: "$4,401 to $11,050" },
        { value: 8.75,  text: "$11,051 to $125,000" },
        { value: 9.9,   text: "Over $125,000" }
      ]
    },
    PA: [{ // Pennsylvania
        value: 3.07,
        text: "Flat rate"
    }],
    RI: { // Rhode Island
      [FILING_STATUS_ENUM.SINGLE]: [
        { value: 3.75,  text: "$0 to $79,900" },
        { value: 4.75,  text: "$79,901 to $181,650" },
        { value: 5.99,  text: "Over $181,650" }
      ],
      [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
        { value: 3.75,  text: "$0 to $79,900" },
        { value: 4.75,  text: "$79,901 to $181,650" },
        { value: 5.99,  text: "Over $181,650" }
      ],
      [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
        { value: 3.75,  text: "$0 to $79,900" },
        { value: 4.75,  text: "$79,901 to $181,650" },
        { value: 5.99,  text: "Over $181,650" }
      ],
      [FILING_STATUS_ENUM.HEAD]: [
        { value: 3.75,  text: "$0 to $79,900" },
        { value: 4.75,  text: "$79,901 to $181,650" },
        { value: 5.99,  text: "Over $181,650" }
      ]
    },
    SC: { // South Carolina
      [FILING_STATUS_ENUM.SINGLE]: [
        { value: 0,     text: "$0 to $3,560" },
        { value: 3,     text: "$3,561 to $17,830" },
        { value: 6.2,   text: "Over $17,830" }
      ],
      [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
        { value: 0,     text: "$0 to $3,560" },
        { value: 3,     text: "$3,561 to $17,830" },
        { value: 6.2,   text: "Over $17,830" }
      ],
      [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
        { value: 0,     text: "$0 to $7,120" },
        { value: 3,     text: "$7,121 to $35,660" },
        { value: 6.2,   text: "Over $35,660" }
      ],
      [FILING_STATUS_ENUM.HEAD]: [
        { value: 0,     text: "$0 to $3,560" },
        { value: 3,     text: "$3,561 to $17,830" },
        { value: 6.2,   text: "Over $17,830" }
      ]
    },
    SD: [{  // South Dakota
        value: 0,
        text: "No state income tax"
    }],
    TN: [{  // Tennessee
        value: 0,
        text: "No state income tax"
    }],
    TX: [{  // Texas
        value: 0,
        text: "No state income tax"
    }],
    UT: [{ // Utah
        value: 4.55,
        text: "Flat rate"
    }],
    VT: { // Vermont
      [FILING_STATUS_ENUM.SINGLE]: [
        { value: 3.35,  text: "$0 to $47,900" },
        { value: 6.60,  text: "$47,901 to $116,000" },
        { value: 7.60,  text: "$116,001 to $242,000" },
        { value: 8.75,  text: "Over $242,000" }
      ],
      [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
        { value: 3.35,  text: "$0 to $39,975" },
        { value: 6.60,  text: "$39,976 to $96,650" },
        { value: 7.60,  text: "$96,651 to $147,325" },
        { value: 8.75,  text: "Over $147,325" }
      ],
      [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
        { value: 3.35,  text: "$0 to $79,950" },
        { value: 6.60,  text: "$79,951 to $193,300" },
        { value: 7.60,  text: "$193,301 to $294,600" },
        { value: 8.75,  text: "Over $294,600" }
      ],
      [FILING_STATUS_ENUM.HEAD]: [
        { value: 3.35,  text: "$0 to $64,200" },
        { value: 6.60,  text: "$64,201 to $157,150" },
        { value: 7.60,  text: "$157,151 to $236,350" },
        { value: 8.75,  text: "Over $236,350" }
      ]
    },
    VA: { // Virginia
      [FILING_STATUS_ENUM.SINGLE]: [
        { value: 2,    text: "$0 to $3,000" },
        { value: 3,    text: "$3,001 to $5,000" },
        { value: 5,    text: "$5,001 to $17,000" },
        { value: 5.75, text: "Over $17,000" }
      ],
      [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
        { value: 2,    text: "$0 to $3,000" },
        { value: 3,    text: "$3,001 to $5,000" },
        { value: 5,    text: "$5,001 to $17,000" },
        { value: 5.75, text: "Over $17,000" }
      ],
      [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
        { value: 2,    text: "$0 to $3,000" },
        { value: 3,    text: "$3,001 to $5,000" },
        { value: 5,    text: "$5,001 to $17,000" },
        { value: 5.75, text: "Over $17,000" }
      ],
      [FILING_STATUS_ENUM.HEAD]: [
        { value: 2,    text: "$0 to $3,000" },
        { value: 3,    text: "$3,001 to $5,000" },
        { value: 5,    text: "$5,001 to $17,000" },
        { value: 5.75, text: "Over $17,000" }
      ]
    },
    WA: [{ // Washington
        value: 0,
        text: 'Does not have state income tax'
    }],
    WV: { // West Virginia
      [FILING_STATUS_ENUM.SINGLE]: [
        { value: 2.22,  text: "$0 to $10,000" },
        { value: 2.96,  text: "$10,001 to $25,000" },
        { value: 3.33,  text: "$25,001 to $40,000" },
        { value: 4.44,  text: "$40,001 to $60,000" },
        { value: 4.82,  text: "Over $60,000" }
      ],
      [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
        { value: 2.22,  text: "$0 to $5,000" },
        { value: 2.96,  text: "$5,001 to $12,500" },
        { value: 3.33,  text: "$12,501 to $20,000" },
        { value: 4.44,  text: "$20,001 to $30,000" },
        { value: 4.82,  text: "Over $30,000" }
      ],
      [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
        { value: 2.22,  text: "$0 to $10,000" },
        { value: 2.96,  text: "$10,001 to $25,000" },
        { value: 3.33,  text: "$25,001 to $40,000" },
        { value: 4.44,  text: "$40,001 to $60,000" },
        { value: 4.82,  text: "Over $60,000" }
      ],
      [FILING_STATUS_ENUM.HEAD]: [
        { value: 2.22,  text: "$0 to $10,000" },
        { value: 2.96,  text: "$10,001 to $25,000" },
        { value: 3.33,  text: "$25,001 to $40,000" },
        { value: 4.44,  text: "$40,001 to $60,000" },
        { value: 4.82,  text: "Over $60,000" }
      ]
    },
    WI: { // Wisconsin
      [FILING_STATUS_ENUM.SINGLE]: [
        { value: 3.5,   text: "$0 to $14,320" },
        { value: 4.4,   text: "$14,321 to $28,640" },
        { value: 5.3,   text: "$28,641 to $315,310" },
        { value: 7.65,  text: "Over $315,310" }
      ],
      [FILING_STATUS_ENUM.FILLING_SEPARATELY]: [
        { value: 3.5,   text: "$0 to $9,550" },
        { value: 4.4,   text: "$9,551 to $19,090" },
        { value: 5.3,   text: "$19,091 to $210,210" },
        { value: 7.65,  text: "Over $210,210" }
      ],
      [FILING_STATUS_ENUM.FILLING_JOINTLY]: [
        { value: 3.5,   text: "$0 to $19,090" },
        { value: 4.4,   text: "$19,091 to $38,190" },
        { value: 5.3,   text: "$38,191 to $420,420" },
        { value: 7.65,  text: "Over $420,420" }
      ],
      [FILING_STATUS_ENUM.HEAD]: [
        { value: 3.5,   text: "$0 to $14,320" },
        { value: 4.4,   text: "$14,321 to $28,640" },
        { value: 5.3,   text: "$28,641 to $315,310" },
        { value: 7.65,  text: "Over $315,310" }
      ]
    },
    WY: [{ // Wyoming
        value: 0,
        text: 'Does not have state income tax'
    }]
}

export const STATE_OPTIONS: StateOption[] = [
    { text: "Alabama", value: "AL" },
    { text: "Alaska", value: "AK" },
    { text: "Arizona", value: "AZ" },
    { text: "Arkansas", value: "AR" },
    { text: "California", value: "CA" },
    { text: "Colorado", value: "CO" },
    { text: "Connecticut", value: "CT" },
    { text: "Delaware", value: "DE" },
    { text: "District of Columbia", value: "DC" },
    { text: "Florida", value: "FL" },
    { text: "Georgia", value: "GA" },
    { text: "Hawaii", value: "HI" },
    { text: "Idaho", value: "ID" },
    { text: "Illinois", value: "IL" },
    { text: "Indiana", value: "IN" },
    { text: "Iowa", value: "IA" },
    { text: "Kansas", value: "KS" },
    { text: "Kentucky", value: "KY" },
    { text: "Louisiana", value: "LA" },
    { text: "Maine", value: "ME" },
    { text: "Maryland", value: "MD" },
    { text: "Massachusetts", value: "MA" },
    { text: "Michigan", value: "MI" },
    { text: "Minnesota", value: "MN" },
    { text: "Mississippi", value: "MS" },
    { text: "Missouri", value: "MO" },
    { text: "Montana", value: "MT" },
    { text: "Nebraska", value: "NE" },
    { text: "Nevada", value: "NV" },
    { text: "New Hampshire", value: "NH" },
    { text: "New Jersey", value: "NJ" },
    { text: "New Mexico", value: "NM" },
    { text: "New York", value: "NY" },
    { text: "North Carolina", value: "NC" },
    { text: "North Dakota", value: "ND" },
    { text: "Ohio", value: "OH" },
    { text: "Oklahoma", value: "OK" },
    { text: "Oregon", value: "OR" },
    { text: "Pennsylvania", value: "PA" },
    { text: "Rhode Island", value: "RI" },
    { text: "South Carolina", value: "SC" },
    { text: "South Dakota", value: "SD" },
    { text: "Tennessee", value: "TN" },
    { text: "Texas", value: "TX" },
    { text: "Utah", value: "UT" },
    { text: "Vermont", value: "VT" },
    { text: "Virginia", value: "VA" },
    { text: "Washington", value: "WA" },
    { text: "West Virginia", value: "WV" },
    { text: "Wisconsin", value: "WI" },
    { text: "Wyoming", value: "WY" },
];
